<div class="row block-title">
  <div class="col-8 pl-0 title">
    <span><svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <title>chart-growth</title>
        <desc>Created with Sketch.</desc>
        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="UI-Dashboard-+-Calendar-02" transform="translate(-735.000000, -983.000000)" fill="#162C4B" fill-rule="nonzero">
            <g id="Suivi" transform="translate(735.000000, 980.000000)">
              <g id="Title">
                <g id="chart-growth" transform="translate(0.000000, 3.000000)">
                  <path d="M8,0 L3,6 L6,6 L6,15 C6,15.6 6.4,16 7,16 L9,16 C9.6,16 10,15.6 10,15 L10,6 L13,6 L8,0 Z" id="Path"></path>
                  <path d="M3,11 L1,11 C0.4,11 0,11.4 0,12 L0,15 C0,15.6 0.4,16 1,16 L3,16 C3.6,16 4,15.6 4,15 L4,12 C4,11.4 3.6,11 3,11 Z" id="Path"></path>
                  <path d="M15,8 L13,8 C12.4,8 12,8.4 12,9 L12,15 C12,15.6 12.4,16 13,16 L15,16 C15.6,16 16,15.6 16,15 L16,9 C16,8.4 15.6,8 15,8 Z" id="Path"></path>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    </span>
   <span i18n="report_monitor|@@report_stats">Suivi des rapports</span>
  </div>
  <div class="col-4 pr-0 date-range">
    <span><svg width="12px" height="7px" viewBox="0 0 12 7" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <title>priority-low</title>
        <desc>Created with Sketch.</desc>
        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="UI-Dashboard-+-Calendar-02" transform="translate(-1049.000000, -174.000000)" fill="#919396" fill-rule="nonzero">
            <g id="Select" transform="translate(895.000000, 155.000000)">
              <g id="Group-4-Copy">
                <g id="priority-low" transform="translate(154.000000, 19.000000)">
                  <path d="M10.3814405,0.586 L6,5.15976904 L1.61855948,0.586 L0.586,1.6638849 L5.48372026,6.7765964 C5.7688789,7.07418253 6.2311211,7.07418253 6.51627974,6.7765964 L11.414,1.6638849 L10.3814405,0.586 Z" id="Path"></path>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    </span>
    <span i18n="report_monitor|@@today">Aujourd'hui</span>
  </div>
</div>
<div class="row block-body">
  <div class="col-12">
    <div class="container">
      <div class="row">
        <div class="col-12 col-lg-6">
          <div class="indicator-wrapper-blue indicator-wrapper-sm">
            <p class="indicator-description-sm indicator-description-blue indicator-description-justify">
              <span>Nbr. scans</span>
              <span class="indicator-trend positive-blue"><svg width="16px" height="8px" viewBox="0 0 16 8" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                  <title>trend</title>
                  <desc>Created with Sketch.</desc>
                  <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
                    <g id="UI-Dashboard-+-Calendar-02" id="global-form-svg" transform="translate(-397.000000, -1345.000000)">
                      <g id="Vos-rapports" transform="translate(165.000000, 980.000000)">
                        <g id="Rapport" transform="translate(0.000000, 48.000000)">
                          <g id="Group-5-Copy-2" transform="translate(155.000000, 198.000000)">
                            <g id="Group-4">
                              <g id="Group-2" transform="translate(77.000000, 113.000000)">
                                <g id="trend-up" transform="translate(8.000000, 10.000000) scale(1, -1) translate(-8.000000, -10.000000) translate(0.000000, 6.000000)">
                                  <polyline id="Path" points="15.5 0.5 8.5 7.5 4.5 3.5 0.5 7.5"></polyline>
                                  <polyline id="Path" points="9.5 0.5 15.5 0.5 15.5 6.5"></polyline>
                                </g>
                              </g>
                            </g>
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </svg> 2,5%</span>
            </p>
            <p class="indicator-value-blue indicator-value-sm">245</p>
          </div>
        </div>
        <div class="col-12 col-lg-6">
          <div class="indicator-wrapper-sm">
            <p class="indicator-description-sm indicator-description indicator-description-justify">
              <span class="d-inline-block d-lg-none d-xl-inline-block" i18n="report_monitor|@@time_for_report_generation">Temps par rapport</span>
              <span class="d-none d-lg-inline-block d-xl-none" i18n="report_monitor|@@time_divided_by_reports">Tps/rapport</span>
              <span class="indicator-trend positive"><svg width="16px" height="8px" viewBox="0 0 16 8" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                  <title>trend</title>
                  <desc>Created with Sketch.</desc>
                  <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
                    <g id="UI-Dashboard-+-Calendar-02" id="global-form-svg" transform="translate(-397.000000, -1345.000000)">
                      <g id="Vos-rapports" transform="translate(165.000000, 980.000000)">
                        <g id="Rapport" transform="translate(0.000000, 48.000000)">
                          <g id="Group-5-Copy-2" transform="translate(155.000000, 198.000000)">
                            <g id="Group-4">
                              <g id="Group-2" transform="translate(77.000000, 113.000000)">
                                <g id="trend-up" transform="translate(8.000000, 10.000000) scale(1, -1) translate(-8.000000, -10.000000) translate(0.000000, 6.000000)">
                                  <polyline id="Path" points="15.5 0.5 8.5 7.5 4.5 3.5 0.5 7.5"></polyline>
                                  <polyline id="Path" points="9.5 0.5 15.5 0.5 15.5 6.5"></polyline>
                                </g>
                              </g>
                            </g>
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </svg> 2,5%</span>
            </p>
            <p class="indicator-value indicator-value-sm d-block d-lg-none d-xl-block">1min 32s</p>
            <p class="indicator-value indicator-value-sm d-none d-lg-block d-xl-none">1:32</p>
          </div>
        </div>
      </div>
      <div class="row graph-container">
        <div class="col-12">
          <img src="assets/images/graph_example.png" style="height: 100%; width:100%;" alt="Graph">
        </div>
      </div>
    </div>


  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/stats/reports-monitor/reports-monitor.component.html